export const CATEGORY_ICON_NAMES = [
  'coffee', 'utensils', 'trees', 'gamepad2', 'calendar', 'gem', 'palette', 'music',
  'shoppingBag', 'beer', 'mapPin', 'camera', 'dumbbell', 'mountain', 'waves', 'tent',
  'wine', 'sandwich', 'flower2', 'landmark', 'theater', 'guitar', 'car', 'bike',
  'sun', 'star', 'heart', 'compass', 'map', 'leaf', 'sparkles', 'lamp', 'umbrella',
  'navigation', 'bird', 'fish', 'bookmark', 'tag'
];

export function getLucideComponentName(iconKey) {
  if (!iconKey) return null;
  return iconKey.charAt(0).toUpperCase() + iconKey.slice(1);
}
